<template>
    <div class="md video-area">
        <a href="#" @click="play"></a>
    </div>
</template>
<script>
    import { mapMutations } from 'vuex'

    export default {
        data: function(){

            return {
                result: {},
            }
        },
        methods: {
            ...mapMutations([
                'pushPopUp'
            ]),
            play: function(){
                // this.pushPopUp({
                //     type: 'videoSelector',
                //     content: {
                        
                //     }
                // })
                this.$router.push('/system/video')
            }
        }
    }
</script>
<style scoped lang="scss">
    .md.video-area {
        @extend %header-btn-caption;

        > a {

            &::before {
                content: '\f06a';
            }
        }
    }
</style>